// extracted by mini-css-extract-plugin
export default {"expandedTextArea":"message-template-content-form-section__expanded-text-area__Crmcj"};